import React from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {PaymentMethodDetails, TGooglePayPaymentMethodStore} from '@/pages/payment-methods'
import {PaymentMethodsGooglePayStoreSymbol} from '@/pages/payment-methods/PaymentMethods/PaymentMethods'
import {PaymentMethodType} from '@/constants'
import {COMPANY_NAME} from '@/constants/app'

export const GooglePayPaymentMethod = observer(() => {
    const {t} = useTranslation()
    const store = useInjection<TGooglePayPaymentMethodStore>(PaymentMethodsGooglePayStoreSymbol)

    return (
        <PaymentMethodDetails
            title={t('GooglePayPaymentMethod.title')}
            description={
                <Trans
                    i18nKey='GooglePayPaymentMethod.description'
                    components={{br: <br />}}
                    values={{companyName: COMPANY_NAME}}
                />
            }
            paymentMethodType={PaymentMethodType.googlepay}
            stores={store.stores}
        />
    )
})
